import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@sdbn/appclient';
import { DictionaryModule } from '@sdbn/appclient';
import { TruckRegistrationSummaryComponent } from './component/truck-registration-summary.component';
import { CommonTranslationModule, CommonUIElementsModule } from '@sdbn/common';



@NgModule({
  declarations: [
    TruckRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    CommonUIElementsModule
  ]
})
export class TruckRegistrationSummaryModule { }
